import { createSlice } from '@reduxjs/toolkit';
import { Service } from 'services/Services';
import { RequestApi } from 'RequestApi';
import { NotificationMessage } from 'components/notification-message/NotificationMessage';
import { setViewingRecord, setProgressingDocument } from 'components/dynamic/dynamic-page/DynamicPageRecordSlice';

const initialState = {
  formLoading: false,
  record: null,
  pageInfo: null,
};

const myTaskActivityRecordSlice = createSlice({
  name: 'myTaskActivityRecord',
  initialState,
  reducers: {
    setPageInfo(state, action) {
      state.pageInfo = action.payload;
    },
    setFormLoading(state, action) {
      state.formLoading = action.payload;
    },
    setRecord(state, action) {
      state.record = action.payload;
    },
  },
});

const { setPageInfo, setFormLoading } = myTaskActivityRecordSlice.actions;

export const { setRecord } = myTaskActivityRecordSlice.actions;

export const initPageInfo =
  ({ informationPage, document }) =>
  async (dispatch) => {
    try {
      dispatch(setFormLoading(true));
      dispatch(setPageInfo(informationPage));
      let url = `${informationPage.url}/index-info?`;
      url += `auth_token=${Service.userToken}`;
      const data = JSON.stringify({
        data_unid: document.id,
      });

      RequestApi(url, {
        data,
      })
        .then((res) => {
          if (res.data.status === 'success') {
            dispatch(setRecord(res.data.record));
            if (!document.status) {
              dispatch(setViewingRecord(res.data.record));
            }
          } else {
            NotificationMessage({ message: res.data.msg, status: res.data.status });
          }
          dispatch(setFormLoading(false));
        })
        .catch((err) => {
          console.log(err);
          dispatch(setFormLoading(false));
          NotificationMessage({ message: err.toString(), status: 'error' });
        });
    } catch (ex) {
      dispatch(setFormLoading(false));
      NotificationMessage({ message: ex.toString(), status: 'error' });
    }
  };

export const updateStatusRecord =
  ({ url, unid, fieldName, valueChanged, record }) =>
  async (dispatch) => {
    try {
      dispatch(setProgressingDocument(true));

      let urlRequest = `${url}/submit-update-status?`;
      urlRequest += `auth_token=${Service.userToken}`;

      const data = JSON.stringify({
        field_name: fieldName,
        value: valueChanged,
        unid,
      });

      RequestApi(urlRequest, {
        data,
      })
        .then((res) => {
          if (res.data.status === 'success') {
            const resRecord = res.data.record;
            const fieldNames = Object.keys(resRecord);
            const tmpRecord = { ...record };

            fieldNames.forEach((objFieldName) => {
              tmpRecord[objFieldName] = resRecord[objFieldName];
            });

            dispatch(setRecord(tmpRecord));
          } else {
            NotificationMessage({ message: res.data.msg, status: res.data.status });
          }
          dispatch(setProgressingDocument(false));
        })
        .catch((err) => {
          dispatch(setProgressingDocument(false));
          NotificationMessage({ message: err.toString(), status: 'error' });
        });
    } catch (ex) {
      dispatch(setProgressingDocument(false));
      NotificationMessage({ message: ex.toString(), status: 'error' });
    }
  };

export const updateRecord =
  ({ url, unid, fieldName, valueChanged, record }) =>
  async (dispatch) => {
    try {
      dispatch(setProgressingDocument(true));

      let urlRequest = `${url}/update-record?`;
      urlRequest += `auth_token=${Service.userToken}`;
      urlRequest += '&source_type=portal';

      const data = JSON.stringify({
        field_name: fieldName,
        value: valueChanged,
        unid,
      });

      RequestApi(urlRequest, {
        data,
      })
        .then((res) => {
          if (res.data.status === 'success') {
            const resRecord = res.data.record;
            const fieldNames = Object.keys(resRecord);
            const tmpRecord = { ...record };
            fieldNames.forEach((objFieldName) => {
              tmpRecord[objFieldName] = resRecord[objFieldName];
            });
            dispatch(setRecord(tmpRecord));
          } else {
            const resRecord = res.data.record;
            const fieldNames = Object.keys(resRecord);
            const tmpRecord = { ...record };
            fieldNames.forEach((objFieldName) => {
              tmpRecord[objFieldName] = resRecord[objFieldName];
            });
            dispatch(setRecord(tmpRecord));

            NotificationMessage({ message: res.data.msg, status: res.data.status });
          }
          dispatch(setProgressingDocument(false));
        })
        .catch((err) => {
          dispatch(setProgressingDocument(false));
          NotificationMessage({ message: err.toString(), status: 'error' });
        });
    } catch (ex) {
      dispatch(setProgressingDocument(false));
      NotificationMessage({ message: ex.toString(), status: 'error' });
    }
  };

const myTaskActivityRecordReducer = myTaskActivityRecordSlice.reducer;

export default myTaskActivityRecordReducer;
